
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getModelList } from "@/api/api-basic";
import selectGun from "@/components/select-gun/select-gun.vue";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import piselectStation from "@/components/select-station/select-station.vue";
import {
  getMonitorGunInfo,
  getPileByDevice
} from "@/api/oms-operation-service";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-select-gun": selectGun,
    "pi-select-oper": piSelectOper,
    "pi-select-station": piselectStation
  }
})
export default class CollectionDataRateConfig extends Vue {
  private formInline: objAny = {
    deviceModelPkId: "",
    pilePkId: "",
    gunPkId: "",
    oprPkId: "",
    staPkId: ""
  };
  private deviceModelName = "";
  private deviceModelList: object[] = [];
  private allPileList: object[] = [];
  private pileList: object[] = [];
  private gunBaseInfo: objAny = {};
  // 获取设备型号
  async getModelList(): Promise<void> {
    const ret = await getModelList({});
    if (ret.status === this.$config.apiStatus) {
      this.deviceModelList = ret.data;
      if (this.formInline.deviceModelPkId == "" && ret.data.length > 0) {
        // this.formInline.deviceModelPkId = ret.data[0].deviceModelPkId;
        this.getPileByDevice();
      }
    }
  }
  public deviceModelChange(val: string) {
    if (val != undefined) {
      this.getPileByDevice();
    }
  }
  //获取桩
  async getPileByDevice(): Promise<void> {
    this.deviceModelList.map((item: objAny) => {
      if (item.deviceModelPkId == this.formInline.deviceModelPkId) {
        this.deviceModelName = item.deviceModelName;
      }
    });
    const ret = await getPileByDevice({
      deviceModelPkId: this.formInline.deviceModelPkId || "",
      oprPkId: this.formInline.oprPkId || "",
      staPkId: this.formInline.staPkId || ""
    });
    if (ret.status === this.$config.apiStatus) {
      if (ret.data) {
        ret.data.map((item: objAny) => {
          if (!item.pileName) {
            item.pileName = "";
          }
        });
        this.allPileList = ret.data;
      } else {
        this.formInline.pilePkId = "";
        this.formInline.gunPkId = "";
        this.allPileList = [];
        this.pileList = [];
      }
    }
  }

  //获取枪基础信息
  async getGunBaseInfo() {
    // this.$emit("success", this.formInline);
    const ret = await getMonitorGunInfo({ gunPkId: this.formInline.gunPkId });
    if (ret.status == this["$config"].apiStatus) {
      this.gunBaseInfo = ret.data[0] || {};
      this.$emit("success", this.formInline, this.gunBaseInfo);
    }
  }
  public gunChange() {
    if (this.formInline.gunPkId != "") {
      this.queryClick();
    } else {
      this.gunBaseInfo = {};
    }
  }
  public queryClick() {
    if (this.formInline.pilePkId == "") {
      this.$Message.error(i18n.t("dataConfig.pilePkIdPl"));
    } else if (this.formInline.gunPkId == "") {
      this.$Message.error(i18n.t("dataConfig.gunPkIdPl"));
    } else {
      this.getGunBaseInfo();
    }

    // this.$emit("success", this.formInline);
  }
  public operChange(val: number | string) {
    this.formInline.oprPkId = val;
    this.getPileByDevice();
  }
  public stationChange(val: number | string) {
    this.formInline.staPkId = val;
    this.getPileByDevice();
  }

  mounted() {
    this.getModelList();
  }
}
